import { createAction } from '@reduxjs/toolkit';

export const SAVE_IMAGE_PMS_COLORS = 'SAVE_IMAGE_PMS_COLORS';
export const SET_NEXTGEN_UI = 'SET_NEXTGEN_UI';
export const CHANGE_NEXTGEN_UI_STATUS = 'CHANGE_NEXTGEN_UI_STATUS';
export const SET_FLYOUT_PANEL_HEIGHT = 'SET_FLYOUT_PANEL_HEIGHT';
export const CHANGE_UPLOADING_FILE_STATUS = 'CHANGE_UPLOADING_FILE_STATUS';
export const SET_ALERT_INFO = 'nextgenUi/setAlertInfo';
export const CHANGE_ELEMENT_APPYING_STATUS = 'changeElementApplyingStatus';
export const UPDATE_RECENT_ART = 'UPDATE_RECENT_ART';

export const setNextgenUi = createAction(SET_NEXTGEN_UI);
export const changeNextgenUiStatus = createAction(CHANGE_NEXTGEN_UI_STATUS);
export const setFlyoutPanelHeight = createAction(SET_FLYOUT_PANEL_HEIGHT);
export const changeCurrentPreviewElementsAction = createAction('nextgenUi/changeCurrentPreviewElementsAction');
export const setPreviewPdfBlob = createAction('nextgenUi/setPreviewPdfBlob');
export const updateSharePanel = createAction('nextgenUi/updateSharePanel');
export const switchShowPreviewWindow = createAction('nextgenUi/switchShowPreviewWindow');
export const switchShowDownloadPdfConfirmMessage = createAction('nextgenUi/switchShowDownloadPdfConfirmMessage');
export const expandImprintFlyout = createAction('nextgenUi/expandImprintFlyout');
export const foldImprintFlyout = createAction('nextgenUi/foldImprintFlyout');
export const showImprintRuleChangeConfirmModal = createAction('nextgenUi/showImprintRuleChangeConfirmModal');
export const closeImprintRuleChangeConfirmModal = createAction('nextgenUi/closeImprintRuleChangeConfirmModal');
export const setShowImageDownloaderConfirmMessage = createAction('nextgenUi/setShowImageDownloaderConfirmMessage');
export const setShowSaveProjectSucessMessage = createAction('nextgenUi/setShowSaveProjectSucessMessage');
export const setAlertInfo = createAction(SET_ALERT_INFO);

export const backupBomOptions = createAction('nextgenUi/backupBomOptions');
export const clearBomOptionsBackup = createAction('nextgenUi/clearBomOptionsBackup');
export const setCurrentBomOption = createAction('nextgenUi/setCurrentBomOption');
export const setCurrentGalleryItem = createAction('nextgenUi/setCurrentGalleryItem');
export const cleanUpRecentBomOptionsList = createAction('nextgenUi/cleanUpRecentBomOptionsList');
export const restoreRecentBomOptionsList = createAction('nextgenUi/restoreRecentBomOptionsList');
export const updateRecentBomOptionsList = createAction('nextgenUi/updateRecentBomOptionsList');

export const setCurrentEditedBomOption = createAction('nextgenUi/bom-options/setCurrentEditedBomOption');
export const clearCurrentEditedBomOption = createAction('nextgenUi/bom-options/clearCurrentEditedBomOption');

export const setProductDetailsInterfaceSettings = createAction('nextgenUi/setProductDetailsInterfaceSettings');
export const changeElementApplyingStatus = createAction(CHANGE_ELEMENT_APPYING_STATUS);
export const initNextgenStepSettings = createAction('nextgenui/initNextgenStepSettings');
export const setNextgenCurrentStep = createAction('nextgenui/setNextgenCurrentStep');
export const setIsMandatorySpecialImageWhenOnlyOneDict = createAction(
  'nextgenUi/setIsMandatorySpecialImageWhenOnlyOneDict'
);
export const setShowSaveProjectModal = createAction('nextgenUi/setShowSaveProjectModal');
export const setImageFlip = createAction('nextgenUi/setImageFlip');
export const setBackupTextColor = createAction('nextgenUi/setBackupTextColor');
export const setBackupTextOutlineColor = createAction('nextgenUi/setBackupTextOutlineColor');
export const changeUploadingFileStatus = createAction(CHANGE_UPLOADING_FILE_STATUS);
export const saveImagePmsColors = createAction(SAVE_IMAGE_PMS_COLORS);
export const updateRecentArt = createAction(UPDATE_RECENT_ART);
export const setShowColorChangeConfirmation = createAction('nextgenUi/setShowColorChangeConfirmation');
export const startRequestPreview = createAction('nextgenUi/startRequestPreview');
export const finishRequestPreview = createAction('nextgenui/finishRequestPreview');
export const setBackupElementsAction = createAction('nextgenUi/setBackupElements');
export const addPMSColor = createAction('nextgenUi/addPMSColor');
export const setBackupColorCharge = createAction('nextgenUi/setBackupColorCharge');
export const addRecentlyUsedColor = createAction('nextgenUi/addRecentlyUsedColor');
export const setFreeColor = createAction('nextgenUi/setFreeColor');
